module.exports = __webpack_public_path__ + "static/media/download.4636b3f3.png";